<template>
  <Question
    :next-button-theme="nextButtonTheme"
    :subtitle="$t('kyc.titles.identity')"
    :title="$t('kyc.questions.maritalStatus')"
    :progress-ratio="3/9/4"
    back-route="/kyc/tax-residence"
    @next="next"
  >
    <BaseSection>
      <BaseRadioButtons
        :items="items"
        :value="maritalStatus"
        class="mb-4"
        @input="updateMaritalStatus"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="slotProps.item.title === maritalStatus"
          class="text-xl"
        >
          {{ slotProps.item.title }}
        </BaseRadioButton>
      </BaseRadioButtons>
    </BaseSection>
  </Question>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { MARITAL_STATUS_ITEMS } from '../../constants';
import Question from './Question.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseRadioButtons from '../../components/BaseRadioButtons.vue';
import BaseRadioButton from '../../components/BaseRadioButton.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'MaritalStatus',
  components: {
    Question,
    BaseSection,
    BaseTitleGroup,
    BaseRadioButtons,
    BaseRadioButton,
  },
  mixins: [kyc],
  data() {
    return {
      items: MARITAL_STATUS_ITEMS,
    };
  },
  computed: {
    ...mapFields('kyc', ['form.attributes.maritalStatus']),
    nextButtonTheme() {
      if (this.maritalStatus) {
        return 'primary';
      }
      return 'disabled';
    },
  },
  methods: {
    next() {
      this.update();
      if (this.maritalStatus === 'Célibataire') {
        this.$router.push('/kyc/children');
      } else if (this.maritalStatus === 'Marié(e)') {
        this.$router.push('/kyc/marriage-type');
      } else {
        this.$router.push('/kyc/spouse');
      }
    },
    updateMaritalStatus(input) {
      this.maritalStatus = input.title;
    },
  },
};
</script>
